module.exports = __webpack_public_path__ + "static/media/mixcloud.eee9220e.svg";